<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
  <!-- <span *ngIf="$.row[$.adata.keyName]">{{splitCapitalCase($.row[$.adata.keyName])}}</span> -->
  <span *ngIf="$.row[$.adata.keyName]">{{ 'TRANSFER.'+$.row[$.adata.keyName] | translate }}</span>
</ng-container>
